
import { Component, Watch } from 'vue-property-decorator';

import { SuppliersApi } from '@/api/SuppliersApi';

import { SupplierResponse } from '@/interfaces/Suppliers';

import { MetaInfo } from 'vue-meta';

import ListPage from '@/views/ListPage.vue';

@Component({
   metaInfo(): MetaInfo {
      return {
         title: 'Activity Suppliers',
      };
   },
})
export default class Activities extends ListPage {
   fields: any[] = [
      {
         key: 'o_name',
         label: 'Nick',
         sortable: true,
      },
      {
         key: 'o_companyname',
         label: 'Company name',
         sortable: true,
      },
      {
         key: 'o_wpage',
         label: 'Website',
         sortable: true,
      },
      {
         key: 'o_owner',
         label: 'Owner',
         sortable: true,
      },
      {
         key: 'o_reservpers',
         label: 'Reservations',
         sortable: true,
      },
      {
         key: 'o_mainpers',
         label: 'Main person',
         sortable: true,
      },
      {
         key: 'o_active',
         label: 'Active',
         sortable: true,
         //formatter: (value: number) => value ? 'Yes' : 'No',
      },
   ];

   filtered: SupplierResponse[] = [];

   filter: any = {};

   mounted() {
      this.findOrders();
   }

   findOrders() {
      if (!this.dataReady) {
         setTimeout(() => this.findOrders(), 1000);
         return;
      }

      this.$store.commit('showLoading');
      this.$store.commit('setItems', { name: 'ready', value: false });

      SuppliersApi.all({ archive: this.is_archive })
         .then(suppliers => {
            this.unfiltered = suppliers;
         })
         .finally(() => {
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   @Watch('$route.query', { deep: true })
   changeQuery() {
      this.findOrders();
   }
}
